// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../public/appointmenspage/delete_interactive.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
  background-color: #fafafa;
  min-height: 100vh;
  padding-left: 132px;
}

input {
  font-family: "Nunito Sans", sans-serif;
}

::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-thumb {
  background-color: #888;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background-color: #555;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.header_in_content_component {
  height: 92px;
  background-color: #ffffff;
  display: flex;
  gap: 57px;
  align-items: center;
  justify-content: start;
  padding: 0px 32px;
  position: sticky;
  width: 100%;
  top: 0;
  z-index: 7;
}

.main_content {
  background-color: #f6f9f9;
}

.appointment_selector {
  display: flex;
  justify-content: space-between;
  padding: 14px;
  border-radius: 6px;
  border: 1px solid #bcc3cd;
  cursor: pointer;
}
.appointment_selector p {
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #47586e;
}
.appointment_selector .arrow-down.svg {
  width: 24px;
  height: 24px;
}

.calendar_active {
  border: 1px solid #1367b5;
}

.drawer_container {
  width: 436px;
  height: 100vh;
  display: flex;
  padding: 32px;
  flex-direction: column;
  background-color: #ffffff;
  position: relative;
}
.drawer_container .drawer_item {
  padding: 16px 0;
}
.drawer_container .drawer_app_item {
  margin-bottom: 20px;
}

.drawer_title_container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.input_search {
  width: 100%;
  border: 1px solid #bcc3cd;
  border-radius: 6px;
  padding: 14px;
  color: #090b0e;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
}
.input_search::placeholder {
  color: #47586e;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
}
.input_search:focus-visible {
  outline: 2px solid #1367b5;
  border: 1px solid transparent;
}

.drawer_listing_list {
  list-style: none;
  overflow-y: auto;
}
.drawer_listing_list .drawer_listing_item {
  padding: 10px 14px;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #090b0e;
  cursor: pointer;
  border-radius: 6px;
  margin-right: 6px;
}
.drawer_listing_list .drawer_listing_item:hover {
  background-color: #f2f4f7;
  transition: background-color 500ms linear;
}

.summary_container {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 32px;
}
.summary_container .summary_item {
  display: flex;
  justify-content: space-between;
}

.error_message {
  text-align: center;
  color: #ad1313;
  margin: -10px;
}

.error_field {
  border: 2px solid #ad1313;
  border-radius: 6px;
}

.service_item_delete {
  min-width: 24px;
  height: auto;
  border-radius: 6px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center;
  cursor: pointer;
}

.header_input_add_button {
  height: 44px;
  display: flex;
  gap: 12px;
  align-items: center;
  border-radius: 6px;
  color: #ffffff;
  background-color: #1367b5;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  padding: 10px 14px;
  transition: all 0.3s linear;
  margin-left: auto;
}
.header_input_add_button:hover {
  background-color: #0f5291;
}

.listing_table {
  width: 100%;
  border-collapse: collapse;
  color: #090b0e;
  margin-bottom: 20px;
}
.listing_table thead {
  background-color: #ebeef2;
  padding: 14px;
}
.listing_table th {
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
}
.listing_table th:first-child {
  padding: 14px;
  text-align: left;
}
.listing_table tr {
  height: 52px;
}
.listing_table tr td {
  text-align: center;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  min-height: 52px;
}
.listing_table tr td:first-child {
  text-align: left;
}
.listing_table tr td:last-child {
  text-align: right;
}
.listing_table tbody tr {
  border-bottom: 1px solid #dce0e5;
}
.listing_table tbody tr td:first-child {
  padding-left: 14px;
}
.listing_table .listing_icons {
  width: 52px;
  height: 52px;
  cursor: pointer;
}

.no_paragraf {
  text-align: right;
  border-bottom: 1px solid #dce0e5;
  padding-bottom: 24px;
}`, "",{"version":3,"sources":["webpack://./src/shared/styles/layout.scss","webpack://./styles/_colors.scss","webpack://./styles/_typography.scss"],"names":[],"mappings":"AAGA;EACI,yBAAA;EACA,iBAAA;EACA,mBAAA;AAFJ;;AAKA;EACI,sCAAA;AAFJ;;AAKA;EACI,UAAA;EACA,WAAA;AAFJ;;AAKA;EACI,sBAAA;EACA,kBAAA;AAFJ;;AAKA;EACI,sBAAA;AAFJ;;AAKA;EACI,mBAAA;EACA,kBAAA;AAFJ;;AAKA;EACI,YAAA;EACA,yBCUU;EDTV,aAAA;EACA,SAAA;EACA,mBAAA;EACA,sBAAA;EACA,iBAAA;EACA,gBAAA;EACA,WAAA;EACA,MAAA;EACA,UAAA;AAFJ;;AAKA;EAEI,yBCvC+B;ADoCnC;;AAMA;EACI,aAAA;EACA,8BAAA;EACA,aAAA;EACA,kBAAA;EACA,yBAAA;EAKA,eAAA;AAPJ;AAGI;EE+BA,gBAAA;EACA,eAAA;EACA,iBAAA;EF/BI,cC3Ba;AD4BrB;AAEI;EACI,WAAA;EACA,YAAA;AAAR;;AAGA;EACI,yBAAA;AAAJ;;AAGA;EACI,YAAA;EACA,aAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,yBCjCU;EDkCV,kBAAA;AAAJ;AACI;EACI,eAAA;AACR;AACI;EACI,mBAAA;AACR;;AAGA;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;AAAJ;;AAGA;EACI,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,cCnEgB;ECyDhB,gBAAA;EACA,eAAA;EACA,iBAAA;AFWJ;AAAI;EACI,cCtEa;ECwDjB,gBAAA;EACA,eAAA;EACA,iBAAA;AFiBJ;AADI;EACI,0BAAA;EACA,6BAAA;AAGR;;AACA;EACI,gBAAA;EACA,gBAAA;AAEJ;AADI;EACI,kBAAA;EE5BJ,gBAAA;EACA,eAAA;EACA,iBAAA;EF4BI,cCvFY;EDwFZ,eAAA;EACA,kBAAA;EACA,iBAAA;AAKR;AAHI;EACI,yBCvFsB;EDwFtB,yCAAA;AAKR;;AADA;EACI,aAAA;EACA,sBAAA;EACA,QAAA;EACA,mBAAA;AAIJ;AAHI;EACI,aAAA;EACA,8BAAA;AAKR;;AADA;EACI,kBAAA;EACA,cCtGkB;EDuGlB,aAAA;AAIJ;;AAFA;EACI,yBAAA;EACA,kBAAA;AAKJ;;AAFA;EACI,eAAA;EACA,YAAA;EACA,kBAAA;EACA,oEAAA;EAEA,eAAA;AAIJ;;AADA;EACI,YAAA;EACA,aAAA;EACA,SAAA;EACA,mBAAA;EACA,kBAAA;EACA,cCzHU;ED0HV,yBC7GmB;EC+BnB,gBAAA;EACA,eAAA;EACA,iBAAA;EF8EA,kBAAA;EACA,2BAAA;EACA,iBAAA;AAMJ;AALI;EACI,yBChKiB;ADuKzB;;AAHA;EACI,WAAA;EACA,yBAAA;EACA,cCpJgB;EDqJhB,mBAAA;AAMJ;AALI;EACI,yBCvIK;EDwIL,aAAA;AAOR;AALI;EEjGA,gBAAA;EACA,eAAA;EACA,iBAAA;EFiGI,kBAAA;AASR;AAPI;EACI,aAAA;EACA,gBAAA;AASR;AAPI;EACI,YAAA;AASR;AARQ;EACI,kBAAA;EE5GR,gBAAA;EACA,eAAA;EACA,iBAAA;EF4GQ,gBAAA;AAYZ;AAXY;EACI,gBAAA;AAahB;AAXY;EACI,iBAAA;AAahB;AANI;EACI,gCAAA;AAQR;AAPQ;EACI,kBAAA;AASZ;AANI;EACI,WAAA;EACA,YAAA;EACA,eAAA;AAQR;;AAJA;EACI,iBAAA;EACA,gCAAA;EACA,oBAAA;AAOJ","sourcesContent":["@import \"../../../styles/colors\";\r\n@import \"../../../styles/_typography.scss\";\r\n\r\n.container {\r\n    background-color: #fafafa;\r\n    min-height: 100vh;\r\n    padding-left: 132px;\r\n}\r\n\r\ninput {\r\n    font-family: \"Nunito Sans\", sans-serif;\r\n}\r\n\r\n::-webkit-scrollbar {\r\n    width: 8px;\r\n    height: 8px;\r\n}\r\n\r\n::-webkit-scrollbar-thumb {\r\n    background-color: #888;\r\n    border-radius: 4px;\r\n}\r\n\r\n::-webkit-scrollbar-thumb:hover {\r\n    background-color: #555;\r\n}\r\n\r\n::-webkit-scrollbar-track {\r\n    background: #f1f1f1;\r\n    border-radius: 4px;\r\n}\r\n\r\n.header_in_content_component {\r\n    height: 92px;\r\n    background-color: $color-white;\r\n    display: flex;\r\n    gap: 57px;\r\n    align-items: center;\r\n    justify-content: start;\r\n    padding: 0px 32px;\r\n    position: sticky;\r\n    width: 100%;\r\n    top: 0;\r\n    z-index: 7;\r\n}\r\n\r\n.main_content {\r\n    // min-height: 100vh;\r\n    background-color: $header-menu-background-container;\r\n}\r\n\r\n.appointment_selector {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    padding: 14px;\r\n    border-radius: 6px;\r\n    border: 1px solid $surfaces-light-white-bg-input;\r\n    p {\r\n        @include typography($body3);\r\n        color: $black-normal-hover;\r\n    }\r\n    cursor: pointer;\r\n    .arrow-down.svg {\r\n        width: 24px;\r\n        height: 24px;\r\n    }\r\n}\r\n.calendar_active {\r\n    border: 1px solid $buttons_stroke_solid;\r\n}\r\n// DRAWERS//\r\n.drawer_container {\r\n    width: 436px;\r\n    height: 100vh;\r\n    display: flex;\r\n    padding: 32px;\r\n    flex-direction: column;\r\n    background-color: $color-white;\r\n    position: relative;\r\n    .drawer_item {\r\n        padding: 16px 0;\r\n    }\r\n    .drawer_app_item {\r\n        margin-bottom: 20px;\r\n    }\r\n}\r\n\r\n.drawer_title_container {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n}\r\n\r\n.input_search {\r\n    width: 100%;\r\n    border: 1px solid $surfaces-light-white-bg-input;\r\n    border-radius: 6px;\r\n    padding: 14px;\r\n    color: $black-dark-active;\r\n    @include typography($body3);\r\n\r\n    &::placeholder {\r\n        color: $black-normal-hover;\r\n        @include typography($body3);\r\n    }\r\n\r\n    &:focus-visible {\r\n        outline: 2px solid $buttons_stroke_solid;\r\n        border: 1px solid transparent;\r\n    }\r\n}\r\n\r\n.drawer_listing_list {\r\n    list-style: none;\r\n    overflow-y: auto;\r\n    .drawer_listing_item {\r\n        padding: 10px 14px;\r\n        @include typography($body-small3);\r\n        color: $black-dark-active;\r\n        cursor: pointer;\r\n        border-radius: 6px;\r\n        margin-right: 6px;\r\n    }\r\n    .drawer_listing_item:hover {\r\n        background-color: $surfaces-normal-hover-white;\r\n        transition: background-color 500ms linear;\r\n    }\r\n}\r\n\r\n.summary_container {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 8px;\r\n    margin-bottom: 32px;\r\n    .summary_item {\r\n        display: flex;\r\n        justify-content: space-between;\r\n    }\r\n}\r\n\r\n.error_message {\r\n    text-align: center;\r\n    color: $error-normal-active;\r\n    margin: -10px;\r\n}\r\n.error_field {\r\n    border: 2px solid $error-normal-active;\r\n    border-radius: 6px;\r\n}\r\n\r\n.service_item_delete {\r\n    min-width: 24px;\r\n    height: auto;\r\n    border-radius: 6px;\r\n    background: url(\"../../../public/appointmenspage/delete_interactive.svg\")\r\n        no-repeat center;\r\n    cursor: pointer;\r\n}\r\n\r\n.header_input_add_button {\r\n    height: 44px;\r\n    display: flex;\r\n    gap: 12px;\r\n    align-items: center;\r\n    border-radius: 6px;\r\n    color: $color-white;\r\n    background-color: $buttons_stroke_solid;\r\n    @include typography($caption2);\r\n    padding: 10px 14px;\r\n    transition: all 0.3s linear;\r\n    margin-left: auto;\r\n    &:hover {\r\n        background-color: $header-menu-text-color;\r\n    }\r\n}\r\n\r\n.listing_table {\r\n    width: 100%;\r\n    border-collapse: collapse;\r\n    color: $black-dark-active;\r\n    margin-bottom: 20px;\r\n    thead {\r\n        background-color: $skeleton_2;\r\n        padding: 14px;\r\n    }\r\n    th {\r\n        @include typography($body2);\r\n        text-align: center;\r\n    }\r\n    th:first-child {\r\n        padding: 14px;\r\n        text-align: left;\r\n    }\r\n    tr {\r\n        height: 52px;\r\n        td {\r\n            text-align: center;\r\n            @include typography($body3);\r\n            min-height: 52px;\r\n            &:first-child {\r\n                text-align: left;\r\n            }\r\n            &:last-child {\r\n                text-align: right;\r\n            }\r\n            // > div {\r\n            //     width: 100%;\r\n            // }\r\n        }\r\n    }\r\n    tbody tr {\r\n        border-bottom: 1px solid $divider;\r\n        td:first-child {\r\n            padding-left: 14px;\r\n        }\r\n    }\r\n    .listing_icons {\r\n        width: 52px;\r\n        height: 52px;\r\n        cursor: pointer;\r\n    }\r\n}\r\n\r\n.no_paragraf {\r\n    text-align: right;\r\n    border-bottom: 1px solid $divider;\r\n    padding-bottom: 24px;\r\n}\r\n","// NAVIGATION\r\n$nav-background-container: #07243f;\r\n$nav-background-container-hover: #0b3e6d;\r\n$nav-background-selected-item: #092e51;\r\n$nav-background-users-cabinet: #109439;\r\n\r\n// GENERAL\r\n\r\n// HEADER MENU\r\n$header-menu-background-container: #f6f9f9;\r\n$header-menu-border-color: #b6d0e8;\r\n// $header-menu-border-color: #e7f0f8;\r\n$header-menu-text-color: #0f5291;\r\n\r\n// SHEDULE TABLE\r\n$event-surface: #f8f6e7;\r\n$shedule-text-color-item-doctor: #546881;\r\n$shedule-item-border-color: #115da3;\r\n$shedule-item-line-color: #ddd;\r\n$shedule-item-title-color: #808080;\r\n$shedule-item-subtitle-color: #151414;\r\n$shedule-drawer-bottum-dorder-color: #dfdede;\r\n\r\n// DRAWER COMPONENT\r\n$drawer-container-bg-color: #bfbfca;\r\n$closed-appointment-bg-color: #e8f9e8;\r\n\r\n// DRAWER COMPONENT\r\n// $drawer-container-bg-color: #bfbfca;\r\n\r\n// BLACK\r\n$black-dark-active: #090b0e;\r\n$black-normal-hover: #47586e;\r\n\r\n// SURFACES\r\n$surfaces-light-hover: #f5f7f9;\r\n$surfaces-light-white-bg-input: #bcc3cd;\r\n$surfaces-normal-hover-white: #f2f4f7;\r\n\r\n// ERROR\r\n$error-normal-active: #ad1313;\r\n$text-error_caption: #ec8d8d;\r\n\r\n// GENERAL//\r\n$color-white: #ffffff;\r\n$divider: #dce0e5;\r\n\r\n$skeleton_2: #ebeef2;\r\n\r\n// ICONS  //\r\n\r\n$icons_grey_2: #909dad;\r\n$icons_success: #119e13;\r\n$icons_warning: #ca6602;\r\n\r\n// BUTTONS  //\r\n$buttons_stroke_outlined_destructive: #f5c6c6;\r\n$buttons_stroke_solid: #1367b5;\r\n$buttons_fill_all_disabled: #d0d6dc;\r\n$buttons_close_chevron_delete_edit_btn_enabled: #546881;\r\n\r\n$buttons_primary_enabled_destructive: #c21616;\r\n\r\n$buttons_primary_pressed_destructive: #a21212;\r\n\r\n$buttons_outlined_enabled: #161919;\r\n$buttons_outlined_hovered: #e7f0f8;\r\n$buttons_outlined_pressed: #dce8f4;\r\n$buttons_outlined_enabled_destructive: #fdf2f2;\r\n$buttons_outlined_hovered_destructive: #fbe9e9;\r\n$buttons_outlined_pressed_destructive: #f9dcdc;\r\n\r\n// LINKS  //\r\n\r\n$link_hovered: #151a20;\r\n$color-white-gray: #e3e3e8;\r\n$color-complete-appointment: #cfcfcf;\r\n","@import \"./colors\";\r\n\r\n$heading1: (\r\n    font-weight: 600,\r\n    font-size: 32px,\r\n    line-height: 40px,\r\n);\r\n\r\n$heading2: (\r\n    font-weight: 500,\r\n    font-size: 24px,\r\n    line-height: 36px,\r\n);\r\n\r\n$heading3: (\r\n    font-weight: 400,\r\n    font-size: 20px,\r\n    line-height: 28px,\r\n);\r\n\r\n$heading4: (\r\n    font-weight: 500,\r\n    font-size: 32px,\r\n    line-height: 40px,\r\n    color: $black-dark-active,\r\n);\r\n\r\n$body1: (\r\n    font-weight: 600,\r\n    font-size: 16px,\r\n    line-height: 24px,\r\n);\r\n\r\n$body2: (\r\n    font-weight: 500,\r\n    font-size: 16px,\r\n    line-height: 24px,\r\n);\r\n\r\n$body3: (\r\n    font-weight: 400,\r\n    font-size: 16px,\r\n    line-height: 24px,\r\n);\r\n\r\n$body-small1: (\r\n    font-weight: 600,\r\n    font-size: 14px,\r\n    line-height: 20px,\r\n);\r\n\r\n$body-small2: (\r\n    font-weight: 500,\r\n    font-size: 14px,\r\n    line-height: 20px,\r\n);\r\n\r\n$body-small3: (\r\n    font-weight: 400,\r\n    font-size: 14px,\r\n    line-height: 20px,\r\n);\r\n\r\n$caption1: (\r\n    font-weight: 500,\r\n    font-size: 12px,\r\n    line-height: 14px,\r\n);\r\n\r\n$caption2: (\r\n    font-weight: 600,\r\n    font-size: 16px,\r\n    line-height: 24px,\r\n);\r\n\r\n$link1: (\r\n    font-weight: 400,\r\n    font-size: 12px,\r\n    line-height: 14px,\r\n);\r\n\r\n$headline3: (\r\n    font-weight: 500,\r\n    font-size: 20px,\r\n    line-height: 28px,\r\n);\r\n\r\n@mixin typography($style) {\r\n    font-weight: map-get($style, font-weight);\r\n    font-size: map-get($style, font-size);\r\n    line-height: map-get($style, line-height);\r\n    @if map-has-key($style, color) {\r\n        color: map-get($style, color);\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
